import React, { useContext, useState, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { Content } from './style'

import {
  SubHeaderContainer,
  LeftSide,
  RightSide,
  SectionName,
  OptionsButton,
  ButtonCreate,
  FilterWrapper,
} from '../../../components/styles/subheader-style'

import { Filter as FilterIcon, Plus } from 'lucide-react'
import OccurencesTable from './OccurencesTable'
import ModalContext from '../../../contexts/ModalContext'
import { OccurrenceContext } from '../../../contexts/OccurrenceContext'
import FilterMenu from '../../../components/SubHeaderFilter/FilterMenu'
import AppliedFiltersDisplay from '../../../components/SubHeaderFilter/AppliedFiltersDisplay'
import { Filter, Header } from '../../../components/SubHeaderFilter/types'

interface TypeMainOutlet {
  search: string
}

export interface OccurrencesOutletType {
  search: string
}

const occurrenceHeaders: Header[] = [
  { key: 'id', label: 'ID', type: 'number' },
  { key: 'operationNumber', label: 'OP', type: 'string' },
  { key: 'companyName', label: 'Cliente', type: 'string' },
  { key: 'description', label: 'Descrição', type: 'string' },
  { key: 'allocation', label: 'Alocação', type: 'string' },
  { key: 'area', label: 'Área', type: 'string' },
  { key: 'sector', label: 'Setor', type: 'string' },
  { key: 'relevant', label: 'Relevante', type: 'boolean' },
]

const OccurrencesSubHeader: React.FC<{
  appliedFilters: Filter[]
  onApplyFilter: (f: Filter) => void
  filterButtonRef: React.MutableRefObject<HTMLDivElement | null>
  isFilterMenuOpen: boolean
  setIsFilterMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ appliedFilters, onApplyFilter, filterButtonRef, isFilterMenuOpen, setIsFilterMenuOpen }) => {
  const { setModalSection, setModalActive } = useContext(ModalContext)
  const { setOccurrence } = useContext(OccurrenceContext)

  const handleNewOccurrence = () => {
    setOccurrence(null)
    setModalSection('createEditOccurrenceModal')
    setModalActive(true)
  }

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>Ocorrências</SectionName>
      </LeftSide>
      <RightSide>
        <FilterWrapper>
          <OptionsButton ref={filterButtonRef} onClick={() => setIsFilterMenuOpen(true)}>
            <FilterIcon size={14} />
          </OptionsButton>
          {isFilterMenuOpen && (
            <FilterMenu
              headers={occurrenceHeaders}
              onApplyFilter={(f) => onApplyFilter(f)}
              onClose={() => setIsFilterMenuOpen(false)}
              anchorRef={filterButtonRef}
              filters={appliedFilters}
            />
          )}
        </FilterWrapper>
        <ButtonCreate onClick={handleNewOccurrence}>
          <Plus size={14} style={{ marginRight: '6px' }} />
          Nova Ocorrência
        </ButtonCreate>
      </RightSide>
    </SubHeaderContainer>
  )
}

const OccurrencesContent: React.FC = () => {
  const { search } = useOutletContext<TypeMainOutlet>()
  const [appliedFilters, setAppliedFilters] = useState<Filter[]>([])
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false)
  const filterButtonRef = useRef<HTMLDivElement | null>(null)

  const handleAddFilter = (f: Filter) => {
    setAppliedFilters(prev => [...prev, f])
  }

  return (
    <>
      <OccurrencesSubHeader
        appliedFilters={appliedFilters}
        onApplyFilter={handleAddFilter}
        filterButtonRef={filterButtonRef}
        isFilterMenuOpen={isFilterMenuOpen}
        setIsFilterMenuOpen={setIsFilterMenuOpen}
      />
      <AppliedFiltersDisplay
        filters={appliedFilters}
        onRemoveFilter={(i: number) => setAppliedFilters(prev => prev.filter((_, idx) => idx !== i))}
        onClearAll={() => setAppliedFilters([])}
      />
      <Content>
        <OccurencesTable search={search} appliedFilters={appliedFilters} />
      </Content>
    </>
  )
}

export default OccurrencesContent
